const textCollator = new Intl.Collator(undefined, { sensitivity: 'accent' });

/** Sort text according to the user's locale without separating upper- and lowercase letters. */
export function compareGridText(left: unknown, right: unknown): number {
  return textCollator.compare(String(left ?? ''), String(right ?? ''));
}
